/* eslint-disable no-undef */
import loadScript from '../../utils/load_script';

export default class JsTagDisplay {
  constructor(videoData) {
    this.URL_JSTAG_LIBRARY = process.env.URL_JSTAG_LIBRARY;
    this.videoData = videoData;
  }

  async loadLibrary() {
    await loadScript(this.URL_JSTAG_LIBRARY);
  }

  async call(adUnit) {
    if (typeof tappxTag === 'undefined') {
      this.loadLibrary();
    }
    if (document.getElementById(adUnit.divId)) {
      document.getElementById(adUnit.divId).innerHTML = '';
    }

    return new Promise((resolve, reject) => {
      window.tappxTag = window.tappxTag || {};
      window.tappxTag.cmd = window.tappxTag.cmd || [];

      window.tappxTag.cmd.push(() => {
        window.tappxTag.requestBid(adUnit, (result, data) => {
          const dataResult = {};
          if (result === 'OK') {
            dataResult.ad = 'JSTAG';
            dataResult.typeAdServer = 'JSTAG';
            dataResult.code = adUnit.divId;
          } else if (result === 'error') {
            dataResult.typeAdServer = 'JSTAG';
            dataResult.message = `JsTag none ads returned`;
            dataResult.error = data;
            reject(dataResult);
          }
          resolve(dataResult);
        });
      });
    });
  }
}
